import SearchForm from './SearchForm'
import Router from 'next/router'
import { constructionFormInputs, constructionAdvancedInputs,
    constructionFormInputsMobile, constructionAdvancedInputsMobile } from '../constructionFormInputs'
import { CONSTRUCTION_LINK_BASE } from '@constants/searchFormLinks'
import paliwo from '@components/search/inputs/paliwo'
import searchFormLink from '@utils/links/searchFormLink'

const ConstructionForm = ({ overrideDefaultValues }) => {
    const navigateToSearchPage = (data) => {
        const link = searchFormLink({
            data,
            linkBase: CONSTRUCTION_LINK_BASE,
            isMakeModelBase: true
        })

        Router.push(link)
    }

    return <SearchForm
        inputs={constructionFormInputs}
        mobileInputs={constructionFormInputsMobile}
        dataKey="budowlane"
        overrideDefaultValues={overrideDefaultValues}
        onSubmit={navigateToSearchPage}
        actionBar={{
            paliwo,
            clear: true,
            advancedOptions: constructionAdvancedInputs,
            advancedOptionsMobile: constructionAdvancedInputsMobile,
        }} />
}

export default ConstructionForm